import React from 'react'
import Hero from '../components/Hero'

function HomeComp() {
  return (
    <>
    <Hero/>
    
    </>
  )
}

export default HomeComp